import * as React from 'react';
import { acscriptsAddress } from 'src/appconfig';

interface Props {
}

interface State {
}

class CompleteWithPermanentFail extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = this.getInitialState();
        window.document.title = 'PermanentFail';
    }

    getInitialState = (): State => {
        return {
        };
    }

    getTheForm() {
        window.open(`${acscriptsAddress.Registration_API}${`Resources/RegistrationForm.pdf`}`, '_blank');
    }

    render(): JSX.Element {
        const { } = this.props;
        const { } = this.state;

        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" id="" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">
                                                            <div className="autoscroll-1 content-wrap"> {/* border-cont */}
                                                                <div className="page-title">Welcome to ACscripts</div>
                                                                <div className="form-row">
                                                                    <p className="col-form-label">Unfortunately there is a problem when verifying your professional credentials or your identity. You have also reached the maximum number of retries per individual.</p>
                                                                    <p className="col-form-label">If you receive this error message, please email us at <span style={{fontStyle: 'italic', fontWeight: 'bold'}}>support@acscripts.com</span>. Sorry for your inconvenience. We will contact you as soon as possible. Thank you.</p>
                                                                </div>
                                                                {/* <form>
                                                                    <div className="font-blue">Option 2. Register Manually</div>
                                                                    <div className="form-row">
                                                                        <textarea id="txtOption1" name="agreement" readOnly={true} defaultValue={`Download e-Prescribing registration form, fill in and fax it to us We will then confirm your registration status as soon as possible`} style={{ width: '640px', height: '50px' }} />
                                                                    </div>
                                                                    <div className="form-row">
                                                                        <button type="button" className="form-button add green right" onClick={this.getTheForm}><i className="fa fa-pencil" /> Get the form</button>
                                                                    </div>
                                                                </form> */}
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <img />
                                                                            </td>
                                                                            <td>
                                                                                <img />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div style={{ textAlign: 'center', fontSize: '10pt' }}>Having questions? Our support team is willing to help.</div>
                                                                <div style={{ textAlign: 'center', fontSize: '10pt' }}>Contact us: <a href="https://www.acscripts.com/help">https://www.acscripts.com/help</a>|<a href="#">support@acscripts.com</a> </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default CompleteWithPermanentFail;


// WEBPACK FOOTER //
// ./src/components/General/CompleteWithPermanentFail.tsx